import script from "./dollar-sign.vue?vue&type=script&setup=true&lang=js"
export * from "./dollar-sign.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__